export default {
  dataIterator: {
    rowsPerPageText: 'Articole pe pagină:',
    rowsPerPageAll: 'Toate',
    pageText: '{0}-{1} din {2}',
    noResultsText: 'Nu au fost găsite înregistrări care să se potrivească',
    nextPage: 'Pagina următoare',
    prevPage: 'Pagina anterioară'
  },
  dataTable: {
    rowsPerPageText: 'Rânduri pe pagină:'
  },
  noDataText: 'Nu există date disponibile',
  carousel: {
    prev: 'Anterior vizual',
    next: 'Următorul vizual'
  }
}
